<template>
  <div
    class="top-info">
    <img
      v-if="imgSrc"
      :src="`/images/${ imgSrc }`"
      alt="">
    <div class="top-info-text">
      <div class="info-title">{{ title }}</div>
      <div class="info-sec">{{ artistName }}</div>
      <div class="info-sec">
        {{ releaseType | toJapanese }}
        / {{ date | formatDate('YYYY-MM-DD') }}
      </div>
      <div
        v-if="ownerEmail"
        class="info-sec">
        管理者： {{ ownerEmail }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevenueShareTopSection',
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    imgSrc: {
      type: String,
      default: '',
    },
    artistName: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    releaseType: {
      type: String,
      default: '',
    },
    ownerEmail: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
img {
  height: 120px;
  width: 120px;
}
@media screen and (max-width: 895px) {
  .info-title {
    font-size: 20px;
  }
  .info-sec {
    font-size: 20px;
  }
}
</style>
